import { limpiarSesionesParaElPortal } from '../pages/admin/legales/legalesAlcance';

export const getUser = () => {
  const userStr = sessionStorage.getItem('user');
  if (userStr) return JSON.parse(userStr);
  else return null;
}
export const getRol = () => {
  const userStr = sessionStorage.getItem('appUserRoles');
  return sessionStorage.getItem('appUserRoles');
}
export const getToken = () => {
  return sessionStorage.getItem('access_token');
}
export const getId = () => {
  return sessionStorage.getItem('id');
}
export const getEmail = () => {
  return sessionStorage.getItem('email');
}
export const getCompany = () => {
  return sessionStorage.getItem('company');
}
export const getDepartment = () => {
  return sessionStorage.getItem('department');
}
export const getArea = () => {
  return sessionStorage.getItem('area');
}
// Cierre de sesión: borra la sesión de la app (access_token, username, totp_session) y también la del portal de
// legales de la pestaña (legales_token, legales_data). Si quedara el legales_token, quien siga en la pestaña entraría
// al portal como la persona que salió. La usan el logout de la app (TopNavbar, Navbar), el del portal
// (LegalesPortalLayout) y los logins cuando el ingreso falla o se abandona (Login, SelectCompanyPage,
// LoginCapacitacion).
export const removeUserSession = () => {
  limpiarSesionesParaElPortal();
  sessionStorage.removeItem('totp_session');
}
export const setUserSession = (token, rol, id, email, company, department, area) => {
  sessionStorage.setItem('access_token', token);
  sessionStorage.setItem('appUserRoles', rol);
  sessionStorage.setItem('id', id);
  sessionStorage.setItem('email', email);
  sessionStorage.setItem('company', company);
  sessionStorage.setItem('department', department);
  sessionStorage.setItem('area', area);
}